import { render, staticRenderFns } from "./Document-table.vue?vue&type=template&id=1f1f45c2"
import script from "./Document-table.vue?vue&type=script&lang=js"
export * from "./Document-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports